'use strict';

define('features/inventory/inventory-landing',[
  'jquery',
  'firstMoverParticipant',
  'bat',
  'responsive',
  'lib/analytics/blocks/index',
  'lib/analytics/pageload',
  'lib/analytics/click',

  // side effect includes
  'bootstrapTab',
  'dropkick',
  'lib/util/tabListControl'
], function (
  $,
  fmp,
  bat,
  responsive,
  blocks,
  anPageLoad,
  anClicks
) {
  var __currentActive = 'all';
  var __useSelect = responsive() !== 'lg';

  var InventoryLanding = function (el, config) {
    this._el = $(el);
    this._config = config;
    this.initialize.apply(this, arguments);
  };

  // TODO: move these off of protoype
  $.extend(InventoryLanding.prototype, {
    initialize: function (el, config) {
      // console.log('InventoryLanding initialize: ', this);
    },

    // .load invoked via inventory.xsl
    load: function () {
      this.$el = $(this._el);
      this.$navLinks = this.$el.find('#lg-tabs a');
      this.$mobileSelect = this.$el.find('#select-vehicle');
      this.$vehicleLinks = this.$el.find('.tab-content a');
      this.listeners();
      bat.util.loader.hideLoader();
      anClicks(this.$el);
      anPageLoad(this.$el, blocks.keyMetrics('km-inventory-search'));
    },

    listeners: function () {
      var self = this;
      window.onhashchange = $.proxy(this.checkHash, self);
      this.navLinks();
      this.mobileSelect();
      this.checkHash();
      // if we're not even in a participating TDA, we do not want to alter the inventory links
      if (BATSiteConfig.gxp && BATSiteConfig.gxp === 'enabled') {
        fmp.attachInventoryClicks(this.$vehicleLinks);
      }
    },

    navLinks: function () {
      var self = this;
      $(self.$navLinks).on('click', function (e) {
        var $this = $(this);
        var $parent = $this.parent();
        self.$navLinks.removeClass('active');
        $this.addClass('active');
        __currentActive = $parent.attr('class').replace(' active', '');
        e.preventDefault();
      });
    },

    mobileSelect: function () {
      var self = this;
      if (__useSelect) {
        self.$mobileSelect.dropkick({ mobile: true });
        $(self.$mobileSelect).on('change', function () {
          __currentActive = $(this).val();
          // need to trigger 'desktop' nav since those contain datalayer-link's
          // and handle the actual DOM update, revealing the selected category of vehicles
          self.navTrigger();
        });
      }
    },

    updateActiveTab: function () {
      this.$el.find('.active').removeClass('active in');
      this.$el.find('.' + __currentActive).addClass('active')
        .children('a').addClass('active');
      this.$el.find('#' + __currentActive).addClass('active in');
    },

    navTrigger: function () {
      this.$navLinks.filter('[href="#' + __currentActive + '"]').trigger('click');
    },

    // Links in BAT footer use hashes
    checkHash: function () {
      var self = this;
      var hash = window.location.hash;
      var hashVal;
      var batHash;

      if (hash.length) {
        if (hash === '#cars-n-minivan') {
          hash = '#cars-n-minivans';
        }
        hashVal = hash.replace('#', '');
        batHash = ['all', 'cars-n-minivans', 'trucks', 'crossovers-n-suvs', 'hybrids-n-evs'];

        if (batHash.indexOf(hashVal) > -1 && __useSelect) {
          self.$mobileSelect.val(hashVal);
          self.$mobileSelect.dropkick('refresh');
        }
        __currentActive = hashVal;
        self.updateActiveTab();
      }
    }
  });

  return InventoryLanding;
});

